import React, { useContext, useState } from 'react';
import { PollResponse } from 'api/api.types';
import { useQuery, UseQueryResult } from 'react-query';
import { Pagesection, Tabs, TabsPanel } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import ApiContext from 'api/ApiContext';
import useMapApi from 'lib/Map/useMapApi';
import MunicipalityView from 'lib/MunicipalityView/MunicipalityView';
import { MuniTab } from 'lib/MapSwitch/MapSwitch';
import CandidateBarsCanton from '../poll/CandidateBarsCanton';
import ElectionAccordeon from './ElectionAccordeon';

interface Props {
  query: UseQueryResult<PollResponse, unknown>;
  isFinal: boolean;
}

const MajorityElectionDetails = ({ query, isFinal }: Props) => {
  const { t } = useTranslation('wap');
  const [selectedMuniTab, setSelectedMuniTab] = useState<MuniTab>('map');

  const { getCountingCircles } = useContext(ApiContext);

  const countingCirclesQuery = useQuery(
    ['counting_circles', query.data.data.info.id],
    () => getCountingCircles(query.data.data.info.id),
  );

  const {
    map,
    hoveredElement: hoveredMapElement,
    selectedElement: selectedMapElement,
    isLoading: isLoadingMap,
    setSelectedElement: setSelectedMapElement,
  } = useMapApi({
    year: new Date(query.data.data.info.date).getFullYear(),
    records: countingCirclesQuery.data?.data?.records,
    type: 'proportional',
    selectedMuniTab,
  });

  if (query.data.data.progress.number_of_finished_counting_circles === 0) return null;
  if (query.isLoading) return null;

  return (
    <Pagesection>
      <Tabs noBezel>
        <TabsPanel label={t('canton')} id="canton">
          <CandidateBarsCanton isFinal={isFinal} query={query} />
        </TabsPanel>
        <TabsPanel label={t('municipalities')} id="municipalities">
          <MunicipalityView
            selectedMuniTab={selectedMuniTab}
            setSelectedMuniTab={setSelectedMuniTab}
            map={map}
            query={countingCirclesQuery}
            hoveredMapElement={hoveredMapElement}
            selectedMapElement={selectedMapElement}
            setSelectedMapElement={setSelectedMapElement}
            isLoadingMap={isLoadingMap}
            render={(municipality) => (
              <ElectionAccordeon
                municipality={municipality}
                candidateList={query.data.data.candidates}
                round={query.data.data.info.majority_election_info?.round_number}
                isFinal={isFinal}
              />
            )}
          />
        </TabsPanel>
      </Tabs>
    </Pagesection>
  );
};

export default MajorityElectionDetails;
